export default __webpack_public_path__ + "static/media/Hygiene & Shaving.88efc27d.png";